// Submit form on click on tag filter
const form = document.querySelector('#form_kesearch_pi1');
const tags = document.querySelectorAll('#kesearch_filters .tag-list-item');

if (form) {
  [...tags].forEach(tag => {
    tag.addEventListener('mouseup', () => {
      var checkbox = tag.querySelector('input[type="checkbox"]');

      if (checkbox.checked) {
        checkbox.removeAttribute("checked");
      } else {
        checkbox.setAttribute("checked", "checked");
      }

      form.submit();
    }, false);
  });
}

export default {};
